import {
  IconCircleCheck,
  IconCircleX,
  IconCircleMinus,
} from '@tabler/icons-react';
import { Badge, Group } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { ConsentStatus } from '@/types/consent.types';

interface ConsentStatusIndicatorProps {
  status: ConsentStatus;
  /** 'badge' renders a labelled badge; 'icon' renders icon only (default) */
  variant?: 'badge' | 'icon';
  size?: number;
}

const STATUS_CONFIG = {
  permit: {
    icon: IconCircleCheck,
    color: 'green',
    i18nKey: 'consent.display.accepted',
  },
  'not-answered': {
    icon: IconCircleMinus,
    color: 'gray',
    i18nKey: 'consent.display.notAnswered',
  },
  deny: {
    icon: IconCircleX,
    color: 'red',
    i18nKey: 'consent.display.declined',
  },
} as const;

export function ConsentStatusIndicator({
  status,
  variant = 'icon',
  size = 20,
}: ConsentStatusIndicatorProps) {
  const { t } = useTranslation('lims');
  const config = STATUS_CONFIG[status] || STATUS_CONFIG['not-answered'];
  const Icon = config.icon;

  if (variant === 'badge') {
    return (
      <Badge color={config.color} variant="light" size="xs">
        <Group gap={3} wrap="nowrap">
          <Icon size={10} />
          {t(config.i18nKey)}
        </Group>
      </Badge>
    );
  }

  return (
    <Icon
      size={size}
      color={`var(--mantine-color-${config.color}-6)`}
      cursor="default"
    />
  );
}
